module.exports = __webpack_public_path__ + "img/img-exchange-sec-10-m.png";